import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';
import { allRondasAction } from '../RondasAction';

const SelectFieldRondasComponent = ({
  onChange,
  value = '',
  data,
  selects = [],
  isAutoComplete,
  idTorneo,
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const rondasStore = Redux.useSelector((state) => state.rondas);

  const [rondas, setRondas] = React.useState([]);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      rondasStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setRondas(items);
    } else {
      if (data) {
        setRondas(data);
      } else {
        setRondas(rondasStore.all);
      }
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && rondasStore.all && rondasStore.all.length === 0) {
        await allRondasAction(dispatch, {
          idTorneo,
        });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.ronda.name}`}>
        {CONST.ronda.label}
      </InputLabel>
      <Select
        id={CONST.ronda.name}
        value={value?.toString()}
        labelId={`label_${CONST.ronda.name}`}
        label={CONST.ronda.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {rondas.map((el, index) => {
          return (
            <MenuItem key={`ronda-${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-rondas"
      opt={rondas}
      type={CONST.ronda.name}
      onChange={(_, newValue) => onChange(newValue?.id)}
      l="Rondas"
    />
  );

  return isAutoComplete ? autoComplete : select;
};

export default SelectFieldRondasComponent;
